__webpack_require__.p = "https://chartering.orcas.uat.sennder.com/";